import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    redirect: { name: "WidgetConfigure" },
    component: () =>
      import(/* webpackChunkName: "overview" */ "../views/Home.vue"),
    children: [
      {
        path: "/widgetconfigure",
        name: "WidgetConfigure",
        component: () =>
          import(
            /* webpackChunkName: "widgetconfigure" */ "../views/WidgetConfigure.vue"
          )
      },
      {
        path: "/widget",
        name: "widget",
        component: () =>
          import(
            /* webpackChunkName: "widgetconfigure" */ "../views/Widget.vue"
          )
      },
      {
        path: "/floating-widget",
        name: "FloatingWidget",
        component: () =>
          import(
            /* webpackChunkName: "floatingwidget" */ "../views/FloatingWidget.vue"
          )
      },
      {
        path: "/reviewgrid",
        name: "ReviewsGrid",
        component: () =>
          import(
            /* webpackChunkName: "reviewsgrid" */ "../views/ReviewsGrid.vue"
          )
      },
      {
        path: "/reviewlist",
        name: "ReviewsList",
        component: () =>
          import(
            /* webpackChunkName: "reviewslist" */ "../views/ReviewsList.vue"
          )
      },

      {
        path: "/reviews",
        name: "Reviews",
        component: () =>
          import(/* webpackChunkName: "reviews" */ "../views/Reviews.vue")
      },
      {
        path: "/plan",
        name: "Plan",
        component: () =>
          import(/* webpackChunkName: "settings" */ "../views/Plan.vue")
      },
      {
        path: "/automation/",
        name: "FullyAutomated",
        redirect: { name: "ReviewRequestConfigure" },
        component: () =>
          import(
            /* webpackChunkName: "automation" */ "../views/FullyAutomated.vue"
          ),
        children: [
          {
            path: "configure",
            name: "ReviewRequestConfigure",
            component: () =>
              import(
                /* webpackChunkName: "reviewrequest" */ "../views/ReviewRequest/ReviewRequestConfigure.vue"
              )
          },
          {
            path: "scheduled",
            name: "ScheduledMails",
            component: () =>
              import(
                /* webpackChunkName: "reviewrequest" */ "../views/ReviewRequest/ScheduledMails.vue"
              )
          },
          {
            path: "customerfeedback",
            name: "CustomerFeedbackList",
            component: () =>
              import(
                /* webpackChunkName: "reviewrequest" */ "../views/ReviewRequest/CustomerFeedback.vue"
              )
          },
          {
            path: "sent",
            name: "SentMails",
            component: () =>
              import(
                /* webpackChunkName: "reviewrequest" */ "../views/ReviewRequest/SentMails.vue"
              )
          }
        ]
      }
    ]
  },

  {
    path: "/privacy-policy",
    component: () =>
      import(/* webpackChunkName: "privacy" */ "../views/PrivacyPolicy.vue")
  },
  {
    path: "/feedback/:storeId",
    component: () =>
      import(/* webpackChunkName: "feedback" */ "../views/FeedbackForm.vue")
  },

  {
    path: "/incident",
    component: () =>
      import(/* webpackChunkName: "incident" */ "../views/Incident.vue")
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue")
  },

  {
    path: "/redirect",
    name: "Redirect",
    component: () =>
      import(/* webpackChunkName: "overview" */ "../views/Redirect.vue")
  },
  {
    path: "/auth/:token",
    name: "AuthRedirect",
    component: () =>
      import(/* webpackChunkName: "overview" */ "../views/AuthRedirect.vue")
  },
  {
    path: "/plan",
    name: "Plan",
    component: () => import(/* webpackChunkName: "plan" */ "../views/Plan.vue")
  }
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes
});

export default router;
